import type { Claim } from 'fhir/r4';
import { gql } from 'graphql-request';
import type { GraphqlConnectionNode, GraphqlPageInfo } from '../client';
import { fragmentClaim } from './fragments/claim';

interface ClaimConnection {
  pageInfo: GraphqlPageInfo;
  edges: Array<GraphqlConnectionNode<Claim>>;
}

export interface ClaimGraphqlResponse {
  ClaimConnection: ClaimConnection;
}

export const claimsQuery = gql`
  ${fragmentClaim}
  query Claims(
    $upid: ID!
    $cursor: String!
    $filter: ClaimFilterParams! = {}
    $sort: ClaimSortParams!
    $first: Int!
  ) {
    ClaimConnection(upid: $upid, after: $cursor, filter: $filter, sort: $sort, first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Claim
        }
      }
    }
  }
`;
